export type HeroEmailExample = {
  sender: string;
  subject: string;
  verdict: "caught" | "passed";
};

export const heroEmailExamples: readonly HeroEmailExample[] = [
  {
    sender: "Maya Patel",
    subject: "Re: Quick idea for your homepage",
    verdict: "caught",
  },
  {
    sender: "Billing Team",
    subject: "Your October invoice is ready",
    verdict: "passed",
  },
  {
    sender: "Jordan Brooks",
    subject: "Following up — extra working capital",
    verdict: "caught",
  },
  {
    sender: "Elena Ruiz",
    subject: "Comment added to launch brief",
    verdict: "passed",
  },
  {
    sender: "Theo Grant",
    subject: "Can we send 20 qualified meetings a month?",
    verdict: "caught",
  },
  {
    sender: "Account Security",
    subject: "New sign-in from Chrome on macOS",
    verdict: "passed",
  },
  {
    sender: "Priya Shah",
    subject: "Re: Senior engineers available next week",
    verdict: "caught",
  },
  {
    sender: "Calendar",
    subject: "Updated invitation: Weekly product review",
    verdict: "passed",
  },
  {
    sender: "Lucas Bennett",
    subject: "Interested in acquiring your domain",
    verdict: "caught",
  },
  {
    sender: "Shipping Updates",
    subject: "Your package arrives tomorrow",
    verdict: "passed",
  },
  {
    sender: "Ava Morgan",
    subject: "Free audit for your growth team",
    verdict: "caught",
  },
  {
    sender: "Payroll",
    subject: "Payroll has been processed",
    verdict: "passed",
  },
  {
    sender: "Owen Park",
    subject: "Family office looking at your company",
    verdict: "caught",
  },
  {
    sender: "Support Desk",
    subject: "Ticket #4821 has a new reply",
    verdict: "passed",
  },
  {
    sender: "Sofia Turner",
    subject: "Quick question about your sales pipeline",
    verdict: "caught",
  },
  {
    sender: "Documents",
    subject: "Access requested: Q4 planning notes",
    verdict: "passed",
  },
  {
    sender: "Ethan Cole",
    subject: "I redesigned your homepage",
    verdict: "caught",
  },
  {
    sender: "Banking Alerts",
    subject: "Upcoming ACH debit scheduled",
    verdict: "passed",
  },
  {
    sender: "Natalie Ross",
    subject: "Open to outsourced product development?",
    verdict: "caught",
  },
  {
    sender: "Events",
    subject: "Reminder: Founder dinner tomorrow",
    verdict: "passed",
  },
  {
    sender: "Marcus Hill",
    subject: "Re: Bookkeeping for your business",
    verdict: "caught",
  },
  {
    sender: "Dev Alerts",
    subject: "Weekly error report: 6 issues resolved",
    verdict: "passed",
  },
  {
    sender: "Chloe Adams",
    subject: "Your competitors are ranking above you",
    verdict: "caught",
  },
  {
    sender: "Receipts",
    subject: "Receipt for your monthly subscription",
    verdict: "passed",
  },
  {
    sender: "Leo Foster",
    subject: "Can I send our AI automation case study?",
    verdict: "caught",
  },
  {
    sender: "Hiring",
    subject: "New application: Senior backend engineer",
    verdict: "passed",
  },
  {
    sender: "Nina Wallace",
    subject: "Last try — coffee while I’m in town?",
    verdict: "caught",
  },
  {
    sender: "Workspace Admin",
    subject: "Your renewal is coming up",
    verdict: "passed",
  },
  {
    sender: "Ryan Ellis",
    subject: "Exclusive invite: Private investor roundtable",
    verdict: "caught",
  },
  {
    sender: "Tax Services",
    subject: "Free tax credit assessment for your team",
    verdict: "caught",
  },
];

export function getHeroEmailInitials(sender: string) {
  return sender
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}
